var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSydneyOperaHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.9982C2 18.4456 2.44772 17.9976 3 17.9976H21C21.5523 17.9976 22 18.4456 22 18.9982V20.9995C22 21.5521 21.5523 22.0001 21 22.0001H3C2.44772 22.0001 2 21.5521 2 20.9995V18.9982Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1936 16.4966C15.5732 14.5855 17.3655 13.5273 19.0217 12.9863C17.246 8.41361 13.1437 2.31761 7.46319 2.00045C7.25144 1.98863 7.11155 2.21086 7.20639 2.40067L9.55701 7.10483C11.0237 10.0401 11.1804 13.4502 10.0063 16.4966H14.1936Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1432 16.4965C17.9752 14.5908 20.3275 14.0274 21.8647 13.9964C21.9149 13.9954 21.9393 14.0557 21.9038 14.0913L21.4765 14.5189C21.1983 14.7972 20.9153 15.1116 20.6243 15.435C20.3045 15.7903 19.9752 16.1563 19.6323 16.4965H16.1432Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61598 16.4966H3.68987C3.60403 15.2061 3.17611 13.9379 2.42231 12.7923L2.01947 12.1801C1.96284 12.094 2.03664 11.9884 2.15195 11.994C3.14279 12.0423 4.04571 12.3654 4.84741 12.8524C5.01973 14.0629 4.9441 15.2956 4.61598 16.4966Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38123 16.4965H6.16297C6.82651 13.644 6.27764 10.6759 4.6033 8.13137L4.02781 7.25674C3.94692 7.1338 4.05235 6.98287 4.21708 6.99091C5.83745 7.07 7.29324 7.66341 8.55594 8.53351C9.5667 11.0528 9.52898 13.8863 8.42703 16.3923L8.38123 16.4965Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSydneyOperaHouse);
export default __webpack_public_path__ + "static/media/sydney-opera-house.a59f5f76800650c9c79eabdc8ac94d9d.svg";
export { ForwardRef as ReactComponent };